module.exports = __webpack_public_path__ + "img/bg-ppt-1.2674bf9a.png";